module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (!phone) { ;
__p += '\n  ';
 if (reset) { ;
__p += '\n    <h2>Set a new password</h2>\n  ';
 } else { ;
__p += '\n    <h2>\n      Please set a password<br />\n      (so you can log in later)\n    </h2>\n  ';
 } ;
__p += '\n';
 } else { ;
__p += '\n  <h3>Set up your account</h3>\n';
 } ;
__p += '\n\n  ';
 if (phone) { ;
__p += '\n    <div class="form-group">\n      <label>Email</label>\n      <input id="email" type="text" placeholder="me@example.com" class="fs-hide" />\n      <span class="help-block hidden"></span>\n    </div>\n    <div class="form-group">\n      <label>Phone</label>\n      <input id="phone" type="tel" placeholder="617-505-5555" class="fs-hide"\n        pattern="[0-9]*" inputmode="numeric" />\n      <span class="help-block hidden"></span>\n    </div>\n\n    <div class="form-group">\n      <label>Choose a password</label>\n  ';
 } ;
__p += '\n\n    <input id="password" type="password" placeholder="Password" />\n    ';
 if (reset) { ;
__p += '\n      <input id="check-password" type="password" placeholder="Re-type password">\n    ';
 } ;
__p += '\n    <span class="help-block hidden"></span>\n    <small id="help-chars">Must be at least 8 characters</small>\n  </div>\n\n';
 if (!phone) { ;
__p += '\n  <div class="modal-actions right">\n    <button id="btn-password" class="btn btn-large btn-primary">Submit</button>\n  </div>\n';
 } ;
__p += '\n';

}
return __p
}